import { render, staticRenderFns } from "./Otros.vue?vue&type=template&id=17574cb1"
import script from "./Otros.vue?vue&type=script&lang=js"
export * from "./Otros.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports